<template>
  <div class="payment-info">
    <absolute-loader :showLoader="showLoader" />
  </div>
</template>

<script>
import AbsoluteLoader from 'theme/components/AbsoluteLoader/AbsoluteLoader'

export default {
  name: 'ResumeInfo',
  data () {
    return {
      showLoader: false
    }
  },
  methods: {
  },
  components: {
    AbsoluteLoader
  }
}
</script>
